export const mapValues = {
  defaultLatitude: 53.1,
  defaultLongitude: -1.6,
  defaultZoom: 6
};
